import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CompanyConfigService, CompanyConfig } from '../../services/company-config.service';

@Component({
  selector: 'app-megamenu',
  templateUrl: './megamenu.component.html',
  styleUrl: './megamenu.component.css',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule
  ]
})
export class MegamenuComponent {
  isScrolled = false;
  isMobileMenuOpen = false;
  activeDropdown: string | null = null;
  hideTimeout: any = null;
  config: CompanyConfig;

  constructor(
    private router: Router,
    private companyConfig: CompanyConfigService
  ) {
    this.config = this.companyConfig.getConfig();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.pageYOffset > 50;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container')) {
      this.activeDropdown = null;
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  showDropdown(menu: string) {
    // Clear any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    this.activeDropdown = menu;
  }

  hideDropdown() {
    // Clear any existing timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    
    // Set a new timeout to hide the dropdown - longer delay for slow mouse movement
    this.hideTimeout = setTimeout(() => {
      this.activeDropdown = null;
      this.hideTimeout = null;
    }, 300); // Increased to 300ms to allow for slower mouse movement
  }

  navigateToLogin() {
    this.router.navigate(['/login']);
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
    this.isMobileMenuOpen = false;
    this.activeDropdown = null;
  }

  callPhone() {
    this.companyConfig.callPhone();
  }

  // Menu data structure
  menuItems = [
    {
      title: 'Services',
      key: 'services',
      megamenu: {
        sections: [
          {
            title: 'Residencial Pest Control',
            items: [
              { name: 'General Pest Control', route: '/general-pest-control' },
              { name: 'Ant Control', route: '/ant-control' },
              { name: 'Cockroach Control', route: '/cockroach-control' },
              { name: 'Spider Control', route: '/spider-control' },
              { name: 'Wasp Control', route: '/wasp-control' },
              { name: 'Rodent Control', route: '/rodent-control' },
              { name: 'Mosquito Control', route: '/mosquito-control' },
            ]
          }
        ]
      }
    },
    {
      title: 'About',
      key: 'about',
      megamenu: {
        sections: [
          {
            title: 'Company',
            items: [
              { name: 'About Complete Pest', route: '/about' },
              { name: 'Our Team', route: '/our-team' },
              { name: 'Service Areas', route: '/service-areas' },
              { name: 'Careers', route: '/careers' }
            ]
          },
          {
            title: 'Resources',
            items: [
              { name: 'Blog', route: '/blog' },
              { name: 'FAQs', route: '/resources/faqs' }
            ]
          }
        ]
      }
    },
    {
      title: 'Pest Research',
      key: 'pest_research',
      megamenu: {
        sections: [
          {
            title: 'Pest Library',
            items: [
              { name: 'All Pests', route: '/pest-library' },
              { name: 'Ants', route: '/pest-library/ants' },
              { name: 'Spiders', route: '/pest-library/spiders' },
              { name: 'Cockroaches', route: '/pest-library/cockroaches' },
              { name: 'Wasps', route: '/pest-library/wasps' },
              { name: 'Rodents', route: '/pest-library/rodents' },
              { name: 'Mosquitoes', route: '/pest-library/mosquitoes' },
              { name: 'Black Widow Spider', route: '/pest-library/black-widow' },
              { name: 'Crickets', route: '/pest-library/crickets' }
            ]
          },
        ]
      }
    }
  ];
}